export default __webpack_public_path__ + "static/media/calculator.8f9deec8.svg";